module.exports = __webpack_public_path__ + "ecce92d0b0ff17197f29e7db6397bf0a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto/roboto-light.woff
// module id = 588
// module chunks = 0